import React, { Component } from "react";
// styles for page
import "./authentication.css";
// images for page
import Logo from "../assets/images/logo.png";
import Loader from "../assets/images/loader.svg";
import LeftPartBg from "../assets/images/forgot_password/image.png";
// import call module
import axios from "axios";
import { Link } from "react-router-dom";

// import ionicons
import Ionicon from "react-ionicons";

export default class ResetEnterPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      urlValid: false,
      token: null,
      changed: false,
      password: "",
      confirmPassword: "",
      passwordValid: null,
      confirmPasswordValid: null,
      passwordTypeLoader: false,
      confirmPasswordTypeLoader: false
    };
    this.buttonActive = null;
    this.passAlertClass = null;
    this.confirmPassAlertClass = null;
    this.iconSize = "45px";
    //  on type timer
    this.timer = null;
    this.typeDelay = 700;
  }
  componentDidMount = () => {
    this.buttonActive = false;
    let url = window.location.pathname;
    let token = url.slice(url.lastIndexOf("/") + 1, url.length);
  };
  handleChange = e => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState(
      {
        [name]: e.target.value,
        // values for validate
        fieldToValidateName: name,
        fieldToValidateValue: value
      },
      this.timerLoader(name, value)
    );
  };
  // delay on field type,show/hide loader
  timerLoader = n => {
    // reset timer
    window.clearTimeout(this.timer);
    // turn on loader ,turn off validation

    this.setState({
      [n + "TypeLoader"]: true,
      [n + "Valid"]: null
    });
    // turn off loader
    setTimeout(() => {
      this.setState({ [n + "TypeLoader"]: false });
    }, 400);
    // // after delay, callback validation function
    this.timer = setTimeout(() => {
      this.checkValidation();
    }, this.typeDelay);
  };
  checkValidation = () => {
    let argName = this.state.fieldToValidateName;
    let argValue = this.state.fieldToValidateValue;
    // check password validation
    if (argName === "password") {
      if (argValue.length > 5) {
        this.setState({
          passwordValid: true
        });
      } else {
        this.setState({
          passwordValid: false
        });
      }
    }
    // check confirm password validation
    if (argName === "confirmPassword") {
      if (this.state.password === argValue && argValue.length > 5) {
        this.setState({
          confirmPasswordValid: true
        });
      } else if (this.state.password !== argValue || argValue.length < 5) {
        this.setState({
          confirmPasswordValid: false
        });
      }
    }
  };
  handleSubmit = event => {
    event.preventDefault();
    axios
      .post(
        `${window.urlPath}/auth/resetPass`,
        { newPass: this.state.password },
        { headers: { token: this.state.token } }
      )
      .then(res => {
        this.changeView();
      });
  };
  changeView = () => {
    this.setState({
      changed: true,
      urlValid: false
    });
  };
  checkUser = token => {
    if (token) {
      this.setState({
        urlValid: true,
        token: token
      });
    } else {
      this.setState({
        urlValid: false,
        token: null
      });
    }
  };
  render() {
    // button state

    if (this.state.confirmPasswordValid) {
      this.buttonActive = true;
    } else {
      this.buttonActive = false;
    }

    // field alert style
    if (this.state.passwordValid !== null) {
      this.state.passwordValid
        ? (this.passAlertClass = "succes")
        : (this.passAlertClass = "warrning");
    }

    if (this.state.confirmPasswordValid !== null) {
      this.state.confirmPasswordValid
        ? (this.confirmPassAlertClass = "succes")
        : (this.confirmPassAlertClass = "warrning");
    }
    //
    const passwordValidHTML = this.state.passwordValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="#36c547"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="#f50c3d"
        />
        <span className="alertText">{`minimum length 6 characters`}</span>
      </React.Fragment>
    );
    const confirmPasswordHTML = this.state.confirmPasswordValid ? (
      <Ionicon
        icon="ios-checkmark"
        fontSize={this.iconSize}
        className="alert"
        color="green"
      />
    ) : (
      <React.Fragment>
        <Ionicon
          icon="ios-close"
          fontSize={this.iconSize}
          className="alert"
          color="red"
        />
        <span className="alertText">{`Passwords need to match`}</span>
      </React.Fragment>
    );

    const PasswordChanged = (
      <div className="Form passwordChanged">
        <div className="formHeading">password succesfully changed</div>
        <label className="centered grayTxt">
          Go to &nbsp;&nbsp;
          <Link to="/login" className="btnLink">
            Login
          </Link>
          &nbsp; page
        </label>
      </div>
    );
    const PasswordConfirm = (
      <div className="Form ">
        <form onSubmit={this.handleSubmit}>
          <img src={Logo} />
          <div className="formHeading">Write new passord</div>
          <label className="labelRelative">
            <input
              type="password"
              placeholder="password"
              name="password"
              onChange={this.handleChange}
              onBlur={this.checkValidation}
              value={this.state.password}
              ref="pass"
              className={this.passAlertClass}
            />
            {this.state.passwordValid !== null ? passwordValidHTML : null}
            {this.state.passwordTypeLoader ? (
              <span className="typeLoader">
                <img src={Loader} />
              </span>
            ) : null}
          </label>
          <label className="labelRelative">
            <input
              type="password"
              placeholder="Confrim password"
              name="confirmPassword"
              onChange={this.handleChange}
              value={this.state.confirmPassword}
              ref="cPass"
              className={this.confirmPassAlertClass}
            />
            {this.state.confirmPasswordValid !== null
              ? confirmPasswordHTML
              : null}
            {this.state.confirmPasswordTypeLoader ? (
              <span className="typeLoader">
                <img src={Loader} />
              </span>
            ) : null}
          </label>
          <button
            className="buttonMid"
            type="submit"
            disabled={!this.buttonActive}
          >
            <span>CONFIRM</span>
          </button>
        </form>
      </div>
    );
    const PasswordConfirmSucces = (
      <div className="Form">
        <form onSubmit={this.handleSubmit}>
          <img src={Logo} />
          <div className="formHeading">Reset Email Sent</div>

          <button className="buttonMid" type="submit">
            RESENT THE EMAIL
          </button>
        </form>
      </div>
    );
    return (
      <React.Fragment>
        <div className="authPage">
          <div className="leftPart grayBg">
            <img src={LeftPartBg} />
          </div>
          <div className="rightPart">
            {this.state.urlValid ? PasswordConfirm : null}
            {this.state.changed ? PasswordChanged : null}
            {!this.state.urlValid && !this.state.changed ? (
              <h1>Page not found</h1>
            ) : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
